const es = {
    homePageH1: "Frases y ejemplos",
    homeMetaDescription: "Aprende a usar palabras en oraciones. Encuentra enunciados y ejemplos de verbos, oraciones compuestas y más. Da con una frase u oración gramaticalmente correcta.",
    homePageMetaTitle: "Ejemplos, frases y oraciones en español",
    homePageMetaKeywords: "frases, oración, oraciones, frase, palabras en oraciones, buscar oraciones, palabras en frases, ejemplo, ejemplos, enunciado, enunciados",
    home: "Inicio",
    byline: "Porque un buen ejemplo vale más que mil palabras",
    copyCtaHome: undefined,
    linkCtaHome: undefined,
    sentenceDetailPageMetaTitle: "Ejemplos de frases y oraciones con la palabra {word}",
    sentenceDetailMetaDescription: "¿Quieres usar {word} en una frase? Te damos {sentenceResultsNumber} ejemplos de frases con la palabra {word} para que aprendas a usar {word} en una oración.",
    sentenceDetailPageH1: "{sentenceResultsNumber} oraciones y frases con <span class='emphasis'>{word}</span>",
    sentenceDetailPageIntroText: "Las oraciones con {word} que te presentamos a continuación te ayudarán a entender cómo debes usar {word} en una frase. Se trata de ejemplos con {word} gramaticalmente correctos que fueron redactados por expertos. Para saber cómo usar {word} en una frase, lee los ejemplos que te sugerimos e intenta crear una oración. ",
    sentenceDetailPageRemoveThumbsUpAltText: undefined,
    sentenceDetailPageThumbsDownAltText: undefined,
    sentenceDetailPageRemoveThumbsDownAltText: undefined,
    sentenceDetailPageFlagAltText: undefined,
    sentenceDetailPageRemoveFlagAltText: undefined,
    sentenceLandingPageTagline: undefined,
    sentenceLandingPageMetaDescription: undefined,
    sentenceLandingPageMetaKeywords: undefined,
    sentenceLandingPageMetaTitle: undefined,
    sentenceDetailPageThumbsUpAltText: undefined,
    sentenceIndexPageMetaDescription: undefined,
    sentenceIndexPageMetaKeywords: undefined,
    sentenceIndexPageH1: undefined,
    sentenceIndexPageMetaTitle: "Índice de frases por palabra",
    sentenceLandingPageH1: undefined,
    sentenceLandingPageH2: undefined,
    sentenceIndex: "Índice de frases",
    relatedArticles: "Artículos relacionados",
    moreArticles: "Más artículos",
    mentionedIn: "Mencionado en",
    nearbyWords: "Palabras cercanas",
    followYDR: "Sigue a YourDictionary",
    typeToSearch: "buscar",
    browseOthers: "Ver otros ejemplos de frases",
    dontRepresent: "Los ejemplos de YourDictionary.com han sido recopilados de diversas fuentes para reflejar el uso actual e histórico de la lengua. Estos ejemplos no representan las opiniones de YourDictionary.com.",
    recentSearches: "Búsquedas recientes",
    aboutUs: "Empresa",
    contactUs: "Contacto",
    pageNotFound: "Página no encontrada",
    suggestionBox: "Sugerencias",
    privacyPolicy: "Política de privacidad",
    termsOfUse: "Condiciones de uso",
    itemCopyright: "Derechos de autor",
    allRightsReserved: "Todos los derechos reservados",
    footerCopyright: undefined,
    weUseCookies: "Este sitio web utiliza cookies propias y de terceros para garantizar una buena experiencia de usuario.",
    learnMore: "Más info",
    gotIt: "OK",
    burgerMenuTitle: "Título del ícono de menú",
    articleDetailMetaTitle: undefined,
    articleDetailMetaDescription: undefined,
    articleDetailMetaKeywords: undefined,
    abbreviationsDentalAbbreviationsMetaDescription: undefined,
    abbreviationsDentalAbbreviationsMetaKeywords: undefined,
    itemDictionary: undefined,
    itemThesaurus: undefined,
    itemExamples: undefined,
    itemSentences: undefined,
    itemQuotes: undefined,
    itemReference: undefined,
    itemSpanish: undefined,
    itemDefinitions: undefined,
    itemSynonyms: undefined,
    itemWordFinder: undefined,
    wfSubMenu1: undefined,
    wfSubMenu2: undefined,
    wfSubMenu3: undefined,
    wfSubMenu4: undefined,
    wfSubMenu5: undefined,
    wfSubMenu6: undefined,
    wfSubMenu7: undefined,
    wfSubMenu8: undefined,
    thesaurusMentionedArticleCard: undefined,
    thesaurusMoreSentenceExampleCard: undefined,
    thesaurusSentenceExampleCard: undefined,
    thesaurusMentionedDictionaryCard: undefined,
    thesaurusNearSynonymsCard: undefined,
    thesaurusLandingPageH1: undefined,
    thesaurusLandingPageH2: undefined,
    thesaurusLandingPageTagline: undefined,
    thesaurusLandingPageMetaTitle: undefined,
    thesaurusLandingPageMetaDescription: undefined,
    thesaurusLandingPageMetaKeywords: undefined,
    thesaurusIndexPageH1: undefined,
    thesaurusIndexPageMetaTitle: undefined,
    thesaurusIndexPageMetaDescription: undefined,
    thesaurusIndexPageMetaKeywords: undefined,
    thesaurusDetailPageH1: undefined,
    thesaurusDefinitionLinkMenu: undefined,
    commonFilter: undefined,
    idiomFilter: undefined,
    antonymFilter: undefined,
    AzFilter: undefined,
    commonWordsSentenceFilter: undefined,
    showShortFirstSentenceFilter: undefined,
    showStarredSentenceFilter: undefined,
    thesaurusAltTextPOS: undefined,
    thesaurusAltTextCommonFilter: undefined,
    thesaurusAltTextSynonym: undefined,
    thesaurusAltTextStar: undefined,
    thesaurusAltTextAz: undefined,
    thesaurusAltTextDefIcon: undefined,
    thesaurusAltTextAntonymsFilter: undefined,
    thesaurus404H1: undefined,
    thesaurus404Message: undefined,
    thesaurusBreadcrumbHome: undefined,
    thesaurusBreadcrumbThesaurus: undefined,
    thesaurusBreadcrumb404: undefined,
    thesaurus404MetaTitle: undefined,
    thesaurus404MetaDescription: undefined,
    uniqueFilter: undefined,
    thesaurusAltTextUniqueFilter: undefined,
    sentenceLandingBody: undefined,
    thesaurusLandingBody: undefined,
    thesaurusDetailPageTitle: undefined,
    thesaurusDetailPageText: undefined,
    thesaurusDetailPageMetaDescription: undefined,
    inviteLoginTitle: undefined,
    inviteLoginText: undefined,
    inviteLoginSigninWithGoogle: undefined,
    loginSignout: undefined,
    loginTooltip: undefined,
    inviteLoginImageAltText: undefined,
    ccpaText: undefined,
    ccpaLink: undefined,
    ccpaTitle: undefined,
    showmoreThesaurus: undefined,
    showmoreThesaurusTitle: undefined,
    showlessThesaurus: undefined,
    showlessThesaurusTitle: undefined,
    ccpaPageYdrLogoAriaLabel: undefined,
    ccpaPageYdrLogoAltText: undefined,
    ccpaPageYdrLogoTitleAttribute: undefined,
    ccpaPageYdrLogoUrl: undefined,
    ccpaPageWfLogoAriaLabel: undefined,
    ccpaPageWfLogoAltText: undefined,
    ccpaPageWfLogoTitleAttribute: undefined,
    ccpaPageWfLogoUrl: undefined,
    ccpaPageH1: undefined,
    ccpaPagePrivacyH2: undefined,
    ccpaPagePrivacyText: undefined,
    ccpaPageInformedH2: undefined,
    ccpaPageInformedText: undefined,
    ccpaPageInformedCheckboxAriaLabel: undefined,
    ccpaPageInformedCheckboxText: undefined,
    ccpaPageOptOutH2: undefined,
    ccpaPageOptOutText: undefined,
    ccpaPageOptOutCheckboxAriaLabel: undefined,
    ccpaPageOptOutCheckboxText: undefined,
    ccpaPageDeleteH2: undefined,
    ccpaPageDeleteText: undefined,
    ccpaPageDeleteCheckboxAriaLabel: undefined,
    ccpaPageDeleteCheckboxText: undefined,
    ccpaPageFormSubmittedButtonText: undefined,
    ccpaPageFullNameText: undefined,
    ccpaPageFullNameAriaLabel: undefined,
    ccpaPageEmailAddressText: undefined,
    ccpaPageEmailAddressAriaLabel: undefined,
    ccpaPagePhoneNumberText: undefined,
    ccpaPagePhoneNumberAriaLabel: undefined,
    ccpaPageStreetAddressText: undefined,
    ccpaPageStreetAddressAriaLabel: undefined,
    ccpaPageStateText: undefined,
    ccpaPageStateAriaLabel: undefined,
    ccpaPageZipCodeText: undefined,
    ccpaPageZipCodeAriaLabel: undefined,
    ccpaPageSubmitButtonText: undefined,
    ccpaPageSubmitButtonAriaLabel: undefined,
    ccpaPageSubmitButtonTitleAttribute: undefined,
    FooterCompanyText: undefined,
    FooterCompanyUrl: undefined,
    FooterCompanyTitleAttribute: undefined,
    FooterContactText: undefined,
    FooterContactUrl: undefined,
    FooterContactTitleAttribute: undefined,
    FooterPrivacyPolicyText: undefined,
    FooterPrivacyPolicyUrl: undefined,
    FooterPrivacyPolicyTitleAttribute: undefined,
    FooterTermsOfUseText: undefined,
    FooterTermsOfUseUrl: undefined,
    FooterTermsOfUseTitleAttribute: undefined,
    filterIcon: undefined,
    showResults: undefined,
    clearFilter: undefined,
    thumbUpAltTextNonSelected: undefined,
    thumbDownAltTextNonSelected: undefined,
    thumbUpAltTextSelected: undefined,
    thumbDownAltTextSelected: undefined,
    SEE_MORE: undefined,
    IDIOMS: undefined,
    SYNONYMS: undefined,
    ANTONYMS: undefined,
    VERB: undefined,
    NOUN: undefined,
    PRON: undefined,
    ADJ: undefined,
    ADV: undefined,
    ADP: undefined,
    CONJ: undefined,
    DET: undefined,
    PRT: undefined,
    MOD: undefined,
    PUNC: undefined,
    NUM: undefined,
    X: undefined,
    ABR: undefined,
    INT: undefined,
    PRE: undefined,
    NNS: undefined,
    AFF: undefined,
    AUXV: undefined,
    CONT: undefined,
    IART: undefined,
    ITV: undefined,
    IV: undefined,
    PRX: undefined,
    PRN: undefined,
    SUF: undefined,
    SYM: undefined,
    TV: undefined,
    VA: undefined,
    VI: undefined,
    VT: undefined,
    relatedFilter: undefined,
    thesaurusAltTextSynonymsFilter: undefined,
    thesaurusAltTextRelatedFilter: undefined,
    thesaurusAltTextIdiomsFilter: undefined,
    sortingBy: undefined,
    sortingByVotes: undefined,
    sortingByRelevance: undefined,
    sortingByAZ: undefined,
    sortingByZA: undefined,
    copyAltTextCopied: undefined,
    copyAltTextCopiedMobile: undefined,
    audioIconTitle: undefined,
    articles404H1: undefined,
    articles404Message: undefined,
    articlesBreadcrumb404: undefined,
    articles404MetaTitle: undefined,
    articles404MetaDescription: undefined,
    Alberto_Molero: undefined,
    Alexis_Vega_Singer: undefined,
    Beth_Parent: undefined,
    Cheryl_Cirelli: undefined,
    Dana_Hinders: undefined,
    Elizabeth_Trach: undefined,
    Jennifer_Betts: undefined,
    Jennifer_Gunner: undefined,
    Kate_Miller_Wilson: undefined,
    Kit_Kittelstad: undefined,
    Matt_Salter: undefined,
    Michael_Kwan: undefined,
    Michele_Meleen: undefined,
    Nicola_Morrison: undefined,
    Renee_Banzhaf: undefined,
    Mary_Gormandy_White: undefined,
    YourDictionary_staff: undefined,
    Anonymous: undefined,
    Other: undefined,
    adsTitle: undefined,
    cookieSettings: undefined,
};

export default es;


// WEBPACK FOOTER //
// ./src/common/multilanguage/translations/es.js